import { message } from "antd";
import { useAuth } from "../../api/useAuth";

const STATUS_COPY = {
  PENDING: {
    color: "#FFB020",
    bg: "rgba(255, 176, 32, 0.10)",
    title: "Identity verification required",
    msg:
      "You can browse and create wallets, but you cannot move funds until your KYC is verified.",
    cta: "Complete KYC",
  },
  REJECTED: {
    color: "#FC555B",
    bg: "rgba(252, 85, 91, 0.10)",
    title: "KYC verification was rejected",
    msg:
      "Your identity verification was not approved. Please re-submit to continue moving funds.",
    cta: "Complete KYC",
  },
  SUSPENDED: {
    color: "#FC555B",
    bg: "rgba(252, 85, 91, 0.10)",
    title: "Account suspended",
    msg:
      "Your account is temporarily suspended. Contact support to restore fund movement.",
    cta: null,
  },
};

const KycBanner = () => {
  const { user } = useAuth();

  if (!user || user.kycStatus === "VERIFIED") return null;

  const copy = STATUS_COPY[user.kycStatus] || STATUS_COPY.PENDING;

  /**
   * Verification is WSO2's, not ours.
   *
   * Both kycStatus and kyc_url on the profile are derived from the identity
   * provider, ARMF only mirrors them. So the only thing this button can do is
   * hand the user over to the onboarding portal. It used to fall back to
   * POST /profile/kyc/submit when no URL was present, which is a route that
   * does not exist (the click failed with "Failed to submit KYC") and, if it
   * had existed, would have been ARMF marking its own customer verified.
   */
  const handleSubmit = () => {
    if (user.kyc_url) {
      window.location.href = user.kyc_url;
      return;
    }
    // No portal link means WSO2 has not issued this user a verification
    // session yet. Say that, rather than failing at a request.
    message.info(
      "Verification isn't ready for your account yet. Please contact support at support@armf.com."
    );
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between gap-3 px-3 py-2 rounded-3 mb-3"
      style={{
        backgroundColor: copy.bg,
        border: `1px solid ${copy.color}`,
      }}
      role="alert"
    >
      <div className="d-flex flex-column">
        <span className="fw-semibold" style={{ color: copy.color }}>
          {copy.title}
        </span>
        <span className="fs12px" style={{ color: "var(--text-main)" }}>
          {copy.msg}
        </span>
      </div>
      {copy.cta && (
        <button
          className="btn btn-sm fw-medium"
          style={{
            backgroundColor: copy.color,
            color: "#fff",
            border: "none",
            whiteSpace: "nowrap",
          }}
          onClick={handleSubmit}
        >
          {copy.cta}
        </button>
      )}
    </div>
  );
};

export default KycBanner;
